function getOwnerWindow(node) {
    return node instanceof Element ? getOwnerDocument(node)?.defaultView ?? window : window;
}
function getOwnerDocument(node) {
    return node instanceof Element ? node.ownerDocument ?? document : document;
}
function dom() {
    return !!(typeof window !== 'undefined' && window.document?.createElement);
}
const isBrowser = dom();

export { dom, getOwnerDocument, getOwnerWindow, isBrowser };
//# sourceMappingURL=dom.js.map
